// extracted by mini-css-extract-plugin
export default {"navContainer":"ManagerHeader_navContainer__IacFh","nav":"ManagerHeader_nav__KdINk"};